import { render } from "./index.vue?vue&type=template&id=cd90ad8e"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
script.render = render

export default script